import { useGetBeheerVestigingen, useSyncVestigingen } from "@/entities/vestiging";
import { VestigingenTable } from "@/features/faciliteiten";
import { Button, Container, DataTableSkeleton } from "@/shared/components";
import { ErrorBoundary, ErrorDisplay } from "@/shared/components/error";
import { Suspense } from "react";

function VestigingenContent() {
    const { data: beheerVestigingen, isPending, error } = useGetBeheerVestigingen();
    const syncVestigingen = useSyncVestigingen();

    if (isPending) {
        return <VestigingenLoading />;
    }

    if (error) {
        return <ErrorDisplay error={error} variant="section" title="Fout bij het laden van vestigingen" />;
    }

    const handleSync = () => {
        syncVestigingen.mutate();
    };

    return (
        <div className="py-6">
            <div className="mb-6 flex items-center justify-between">
                <div>
                    <h1 className="text-xxl font-bold text-gray-900">Faciliteiten</h1>
                    <p className="text-s mt-2 text-gray-600">Beheer en monitor alle vestigingen voor faciliteiten</p>
                </div>
                <Button
                    variant="secondary"
                    onClick={handleSync}
                    disabled={syncVestigingen.isPending}
                    icon="refresh"
                    data-testid="sync-vestigingen"
                >
                    {syncVestigingen.isPending ? "Synchroniseren..." : "Sync met Places API"}
                </Button>
            </div>
            <VestigingenTable vestigingen={beheerVestigingen} />
        </div>
    );
}

/**
 * Loading fallback component for when vestigingen are being fetched
 */
function VestigingenLoading() {
    return (
        <div className="flex flex-col gap-4">
            <div className="mb-6 flex items-center justify-between">
                <div>
                    <h1 className="text-xxl font-bold text-gray-900">Vestigingenoverzicht</h1>
                    <p className="text-s mt-2 text-gray-600">Laden van vestigingen...</p>
                </div>
            </div>
            <DataTableSkeleton rowCount={10} columnCount={8} />
        </div>
    );
}

export default function VestigingenPage() {
    return (
        <Container fluid>
            <ErrorBoundary
                fallback={(error) => <ErrorDisplay error={error} variant="section" title="Fout bij het laden van vestigingen" />}
            >
                <Suspense fallback={<VestigingenLoading />}>
                    <VestigingenContent />
                </Suspense>
            </ErrorBoundary>
        </Container>
    );
}
